export const PREMIUM_PLANS = [
  { id: "monthly", name: "Monthly", hi: "Mahine ka", price: 299, period: "1 mahina", tag: "" },
  { id: "yearly", name: "1 Saal", hi: "Saal bhar", price: 1999, period: "12 mahine · ~₹167/mo", tag: "Popular" },
  { id: "lifetime", name: "Lifetime", hi: "Hamesha ke liye", price: 4999, period: "ek baar pay, hamesha", tag: "Best Value" },
];
